import { FormItemProps } from './types'

const FormLine = (props: FormItemProps) => {
    const { item, className, lineClassName, isPropertySpace } = props
    const divWidth = isPropertySpace ? '33.33%' : ''
    const divider = isPropertySpace ? <div className="text-center">/</div> : ''

    return (
        <div className={`d-flex mb-2 ${className || ''}`} style={{ width: divWidth }}>
            <div className="fs-12 me-3">{item.field}:</div>
            <div className={`${lineClassName || ''} border-bottom border-primary`}>{divider}</div>
        </div>
    )
}

export default FormLine
